module.exports =`
<table style="width: 300px; color: #ae9277; font-family: Arial; border:0; border-spacing: 0px;">
<tbody>
<tr style="height: 17px;">
<td style="vertical-align: top; height: 70px; width: 75px; padding-top:6px;" rowspan="5">
<img src="https://assets.enchantchristmas.com/web/e-mark.png" alt="" width="60" height="60"></td>
<td style="height: 16px; padding-top: 10px; width: 265px; font-family: Arial; font-size: 13px; vertical-align: bottom; mso-line-height-rule: exactly; line-height:8px;">
<b>{{name}}</b></td>
</tr>
<tr style="height: 15px;">
<td style="height: 15px; width: 265px; font-family: Arial; font-size: 10px; text-transform: uppercase; vertical-align: top;">
{{title}}</td>
</tr>
<tr style="height: 12px;">
<td style="height: 12px; width: 265px; padding-top: 4px; font-family: Arial;font-size: 10px; mso-line-height-rule: exactly;  line-height:10px;">
{{phone}}</td>
</tr>
<tr style="height: 10px;">
<td style="mso-line-height-rule: exactly; padding-top: 2px; line-height: 5px;height: 10px; width: 265px; font-family: Arial;font-size: 10px;vertical-align: top; text-decoration: none;">
www.enchantchristmas.com</td>
</tr>
<tr style="height: 18px;">
<td style="height: 18px; width: 265px; padding-top: 5px; font-family: Arial; font-size: 10px;vertical-align: bottom;">
<a target="_blank" href="https://www.instagram.com/enchantchristmas/" style="padding-right: 3px; text-decoration: none;"><img src="https://assets.enchantchristmas.com/web/instagram-logo.png" width="12" height="12"></a>
<a target="_blank" href="https://www.facebook.com/EnchantChristmas/" style="padding-right: 3px; text-decoration: none;"><img src="https://assets.enchantchristmas.com/web/facebook-logo.png" width="12" height="12"></a>
<a target="_blank" href="https://twitter.com/enchantxmas" style="padding-right: 3px; text-decoration: none;"><img src="https://assets.enchantchristmas.com/web/twitter-logo.png" width="12" height="12"></a>
</td>
</tr>
</tbody>
</table>
`
